var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "driver-info-management" },
    [
      _c(
        "el-card",
        [
          _c("div", { staticClass: "top-bar" }, [
            _c(
              "div",
              { staticClass: "search-box" },
              [
                _c("el-input", {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "司机姓名", clearable: "" },
                  model: {
                    value: _vm.searchForm.realName,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "realName", $$v)
                    },
                    expression: "searchForm.realName",
                  },
                }),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { width: "150px" },
                  attrs: { placeholder: "手机号", clearable: "" },
                  model: {
                    value: _vm.searchForm.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "phone", $$v)
                    },
                    expression: "searchForm.phone",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.searchLoading },
                    on: { click: _vm.handleSearch },
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c("el-button", { on: { click: _vm.resetSearch } }, [
                  _vm._v("重置"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-plus" },
                    on: { click: _vm.openCreateDialog },
                  },
                  [_vm._v("新增司机")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": {
                  backgroundColor: "#e8eaed",
                  color: "#333",
                  fontWeight: "bold",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "140", fixed: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.openEditDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#f56c6c" },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "realName",
                  label: "司机姓名",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "gender", label: "性别", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.gender === 1 ? "男" : "女")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", "min-width": "130" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "age", label: "年龄", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "drivingYears",
                  label: "驾龄(年)",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.status === 0 ? "success" : "warning",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.status === 0 ? "正常" : "禁用"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.pagination.page + 1,
              "page-size": _vm.pagination.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.pagination.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handlePageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增司机",
            visible: _vm.createVisible,
            width: "500px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createForm",
              attrs: {
                model: _vm.createForm,
                rules: _vm.createRules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名", prop: "realName" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { flex: "1" },
                        attrs: { placeholder: "请输入司机姓名" },
                        model: {
                          value: _vm.createForm.realName,
                          callback: function ($$v) {
                            _vm.$set(_vm.createForm, "realName", $$v)
                          },
                          expression: "createForm.realName",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-left": "8px",
                            "flex-shrink": "0",
                          },
                          attrs: { icon: "el-icon-more", size: "small" },
                          on: { click: _vm.openQywxDialog },
                        },
                        [_vm._v("企业微信")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "性别", prop: "gender" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.createForm.gender,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "gender", $$v)
                        },
                        expression: "createForm.gender",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("男")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("女")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.createForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "phone", $$v)
                      },
                      expression: "createForm.phone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "年龄", prop: "age" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 18, max: 80 },
                    model: {
                      value: _vm.createForm.age,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "age", $$v)
                      },
                      expression: "createForm.age",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "驾龄(年)", prop: "drivingYears" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, max: 60 },
                    model: {
                      value: _vm.createForm.drivingYears,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "drivingYears", $$v)
                      },
                      expression: "createForm.drivingYears",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "12px",
                color: "#909399",
                "margin-bottom": "8px",
              },
            },
            [_vm._v("账户不存在时会用手机号注册账户，密码默认123456")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.createVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.createLoading },
                  on: { click: _vm.handleCreate },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改司机",
            visible: _vm.editVisible,
            width: "500px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editForm",
              attrs: {
                model: _vm.editForm,
                rules: _vm.editRules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名", prop: "realName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入司机姓名" },
                    model: {
                      value: _vm.editForm.realName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "realName", $$v)
                      },
                      expression: "editForm.realName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "性别", prop: "gender" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.editForm.gender,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "gender", $$v)
                        },
                        expression: "editForm.gender",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("男")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("女")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.editForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "phone", $$v)
                      },
                      expression: "editForm.phone",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "年龄", prop: "age" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 18, max: 80 },
                    model: {
                      value: _vm.editForm.age,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "age", $$v)
                      },
                      expression: "editForm.age",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "驾龄(年)", prop: "drivingYears" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, max: 60 },
                    model: {
                      value: _vm.editForm.drivingYears,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "drivingYears", $$v)
                      },
                      expression: "editForm.drivingYears",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.editLoading },
                  on: { click: _vm.handleEdit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择企业微信用户",
            visible: _vm.qywxVisible,
            width: "550px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.qywxVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.qywxUserList,
                "highlight-current-row": "",
                "max-height": "400",
              },
              on: { "row-click": _vm.handleQywxSelect },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "姓名", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "企微部门", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.departmentName || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }